// modal/detail/ui/SoftCard.jsx
import React from 'react';
import Card from '@mui/material/Card';
import { useTheme as useMuiTheme } from '@mui/material/styles';

export function SoftCard({ children, sx }) {
  const theme = useMuiTheme();

  return (
    <Card
      sx={{
        p: 2,
        borderRadius: '18px',
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: theme.shadows[2],
        background: theme.palette.background.paper,
        ...sx,
      }}
    >
      {children}
    </Card>
  );
}
